/**
 * Compteur (miroir module) du nombre de widgets par type actuellement sur la grille.
 *
 * Le parcours d'ajout (catalogue) est sur une route distincte du dashboard, donc
 * hors du GridStackProvider : il ne peut pas lire la grille vivante directement.
 * Le dashboard publie ici le décompte courant (via WidgetCountTracker), et la page
 * catalogue le lit pour limiter certains types (ex. WeatherWidget = 3 appels API max).
 *
 * Même principe que gridMetrics : une donnée partagée hors React, simple à lire
 * de n'importe quelle route.
 */
import { WidgetTypeId } from "./widgetCatalog";

let counts: Partial<Record<WidgetTypeId, number>> = {};

export function setWidgetCounts(next: Partial<Record<WidgetTypeId, number>>) {
  counts = next;
}

export function getWidgetCount(type: WidgetTypeId): number {
  return counts[type] ?? 0;
}
